import { render, staticRenderFns } from "./buyerOrderHistory.vue?vue&type=template&id=7f51e58c&scoped=true&"
import script from "./buyerOrderHistory.vue?vue&type=script&lang=js&"
export * from "./buyerOrderHistory.vue?vue&type=script&lang=js&"
import style0 from "./buyerOrderHistory.vue?vue&type=style&index=0&id=7f51e58c&prod&lang=less&scoped=true&"
import style1 from "./buyerOrderHistory.vue?vue&type=style&index=1&id=7f51e58c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f51e58c",
  null
  
)

export default component.exports